import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import {
GlassesFilled,
Heart,
Legal,
UserShield,
Tooth,
Child,
HeartInHand,
UserInjured,
UserDoctor,
UserNurse,
UserClock,
UserPen,
UserGroup,
UserCheck } from "../icons";

import React from 'react';











export var ProductLineSectionType;(function (ProductLineSectionType) {ProductLineSectionType["GENERAL"] = "GENERAL";ProductLineSectionType["ANCILLARY"] = "ANCILLARY";})(ProductLineSectionType || (ProductLineSectionType = {}));








export var PRODUCT_LINES_CONTENT_MAP = _Object$freeze({
  GroupHealth: {
    label: 'Medical',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(Heart, { width: width });},
    order: 0,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.GENERAL
  },
  GroupDental: {
    label: 'Dental',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(Tooth, { width: width });},
    order: 1,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.GENERAL
  },
  GroupVision: {
    label: 'Vision',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(GlassesFilled, { width: width });},
    order: 2,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.GENERAL
  },
  GroupEmployerPaidSTD: {
    label: 'Employer Paid STD',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserDoctor, { width: width });},
    order: 3,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupVoluntarySTD: {
    label: 'Voluntary STD',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserNurse, { width: width });},
    order: 4,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupEmployerPaidLTD: {
    label: 'Employer Paid LTD',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserInjured, { width: width });},
    order: 5,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupVoluntaryLTD: {
    label: 'Voluntary LTD',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserClock, { width: width });},
    order: 6,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupBasicLife: {
    label: 'Basic Life',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(HeartInHand, { width: width });},
    order: 7,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupVoluntaryTermLife: {
    label: 'Voluntary Term Life',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserPen, { width: width });},
    order: 8,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupSpouseVTL: {
    label: 'Spouse VTL',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserGroup, { width: width });},
    order: 9,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupChildVTL: {
    label: 'Child VTL',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(Child, { width: width });},
    order: 10,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupDependentVTL: {
    label: 'Dependent VTL',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserCheck, { width: width });},
    order: 11,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupLegal: {
    label: 'Legal',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(Legal, { width: width });},
    order: 12,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  GroupLumpSum: {
    label: 'Lump Sum',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(UserShield, { width: width });},
    order: 13,
    rateSegment: 'GROUP',
    section: ProductLineSectionType.ANCILLARY
  },
  IndividualDental: {
    label: 'Dental',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(Tooth, { width: width });},
    order: 0,
    rateSegment: 'INDIVIDUAL',
    section: ProductLineSectionType.GENERAL
  },
  AssociationDental: {
    label: 'Dental',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(Tooth, { width: width });},
    order: 0,
    rateSegment: 'ASSOCIATION',
    section: ProductLineSectionType.GENERAL
  },
  AssociationVision: {
    label: 'Vision',
    icon: function icon(width) {return /*#__PURE__*/React.createElement(GlassesFilled, { width: width });},
    order: 1,
    rateSegment: 'ASSOCIATION',
    section: ProductLineSectionType.GENERAL
  }
});

export var sortedProductLines = [
'Medical',
'Dental',
'Vision',
'Employer Paid STD',
'Voluntary STD',
'Employer Paid LTD',
'Voluntary LTD',
'Basic Life',
'Voluntary Term Life',
'Spouse VTL',
'Child VTL',
'Dependent VTL',
'Legal',
'Lump Sum'];


export function getProductLinesFromArray(pLineIds) {
  return _mapInstanceProperty(pLineIds).call(pLineIds, function (pLineId) {return PRODUCT_LINES_CONTENT_MAP[pLineId].label;}).join(', ');
}

export var sortByProductLineId = function sortByProductLineId(a, b) {
  return (
    PRODUCT_LINES_CONTENT_MAP[a].order -
    PRODUCT_LINES_CONTENT_MAP[b].order);

};
//# sourceMappingURL=ProductLinesHelper.js.map